var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarhire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 63.118,
    y1: 64.935,
    x2: 33.259,
    y2: 64.935
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 33.259,
    y1: 64.935,
    x2: 33.201,
    y2: 64.935
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 81.384,
    y1: 64.935,
    x2: 81.34,
    y2: 64.935
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M81.384,64.935h13.032c0.328-0.175,1.408-0.854,2.424-2.684c0.301-0.538,0.381-0.991,0.241-1.344 c-0.238-0.593-1.038-0.869-1.045-0.871c-0.334-0.105-0.561-0.414-0.561-0.766V52.67c0-0.317-0.816-1.665-3.246-3.604 c-2.131-1.703-4.418-2.982-5.964-3.339c-3.519-0.812-10.282-0.822-10.35-0.822c-0.285,0-0.55-0.151-0.693-0.397 c-0.025-0.043-2.617-4.41-8.185-8.511c-5.122-3.774-13.896-8.094-26.603-7.243C14.485,30.492,5.597,47.496,4.522,56.244 c-0.016,0.128-0.063,0.251-0.136,0.357c-0.202,0.293-0.471,0.565-0.756,0.855c-0.874,0.886-1.864,1.893-1.771,4.026 c0.103,2.37,2.987,3.3,3.518,3.451h9.602"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M37.759,33.217c-2.795,0.112-12.877,1.11-19.759,9.479h19.759V33.217z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M67,42.66c-1.091-1.043-2.903-2.578-5.455-4.1c-4.064-2.424-10.878-5.307-20.384-5.392v9.492H67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M83,48.868l3.376,4.138h4.152c-0.772-1.239-2.197-3.127-4.029-3.779c-0.846-0.3-1.675-0.453-2.466-0.453 C83.635,48.774,83.287,48.813,83,48.868z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M33.259,64.935c0.006-0.146,0.012-0.29,0.012-0.437c0-5.087-3.937-9.225-9.022-9.225c-5.086,0-9.224,4.138-9.224,9.225 c0,5.086,4.138,9.223,9.224,9.223c4.568,0,8.169-3.34,8.895-7.705c0.003-0.074,0.015-0.146,0.034-0.215 C33.217,65.516,33.244,65.227,33.259,64.935"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M81.384,64.935c0.007-0.146,0.012-0.29,0.012-0.437c0-5.087-3.937-9.225-9.022-9.225c-5.087,0-9.224,4.138-9.224,9.225 c0,5.086,4.137,9.223,9.224,9.223c4.569,0,8.17-3.34,8.896-7.705c0.004-0.074,0.016-0.146,0.033-0.215 C81.343,65.516,81.369,65.227,81.384,64.935"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M27.673,64.411c0-1.907-1.553-3.462-3.462-3.462c-1.908,0-3.461,1.555-3.461,3.462c0,1.909,1.553,3.462,3.461,3.462 C26.12,67.873,27.673,66.32,27.673,64.411z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M75.798,64.411c0-1.907-1.552-3.462-3.461-3.462c-1.908,0-3.462,1.555-3.462,3.462c0,1.909,1.554,3.462,3.462,3.462 C74.246,67.873,75.798,66.32,75.798,64.411z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarhire);
export default __webpack_public_path__ + "static/media/carhire.7f8f49f87b7c6bd618df0111bdac1efc.svg";
export { ForwardRef as ReactComponent };